import type { SVGProps } from 'react';

const SvgRoleGroups = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m20.71 12.29-1-1a.996.996 0 0 0-1.41 0l-4 4c-.39-.19-.82-.3-1.29-.3-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3c0-.46-.11-.9-.3-1.29l.79-.79.79.79c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-.79-.79 1.09-1.09.29.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zM13 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m-1.47-7.51c.66.34 1.24.82 1.67 1.44.19.28.5.43.82.43.2 0 .4-.06.57-.18.45-.32.56-.94.25-1.39a6.5 6.5 0 0 0-1.7-1.66c.54-.74.87-1.65.87-2.63 0-2.48-2.02-4.5-4.5-4.5s-4.5 2.02-4.5 4.5c0 .98.33 1.89.86 2.63a6.45 6.45 0 0 0-2.86 5.37c0 .55.45 1 1 1s1-.45 1-1c0-1.71.97-3.24 2.47-4 .61.31 1.29.5 2.03.5s1.42-.19 2.03-.51zM9.5 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5"
    />
  </svg>
);
export default SvgRoleGroups;
